import { render, staticRenderFns } from "./BlogLinkSuggestion.vue?vue&type=template&id=28e321aa&scoped=true"
import script from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
export * from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
import style0 from "./BlogLinkSuggestion.vue?vue&type=style&index=0&id=28e321aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e321aa",
  null
  
)

export default component.exports